import { DateRange } from '../components/common-filters';

export interface BaseFilters {
  name?: string;
  fileType?: 'Pdf' | 'Document' | 'Spreadsheet' | 'Photo' | 'Xlsx' | 'Csv' | 'Vsdx' | 'Pptx' | 'Json';
}

export type LibraryTab = 'all' | 'files' | 'folders';

export interface FileManagerFilters extends BaseFilters {
  lastModified?: DateRange;
  sharedBy?: string;
  libraryTab?: LibraryTab;
}

export interface SharedFilters extends BaseFilters {
  sharedBy?: string;
  sharedDate?: DateRange;
  lastModified?: DateRange;
}

export interface TrashFilters extends BaseFilters {
  deletedBy?: string;
  trashedDate?: DateRange;
}

export type FilterType = FileManagerFilters | SharedFilters | TrashFilters;

export interface FilterConfig {
  key: string;
  type: 'select' | 'dateRange' | 'user';
  label: string;
  options?: Array<{ value: string; label: string }>;
  users?: Array<{ id: string; name: string }>;
  showInMobile?: boolean;
  showInDesktop?: boolean;
  width?: string;
}

export interface ActionConfig {
  key: string;
  label: string;
  icon: React.ComponentType<any>;
  variant?: 'default' | 'outline' | 'ghost';
  onClick: () => void;
  showWhen?: (selectedItems: string[]) => boolean;
  size?: 'sm' | 'default';
  disabled?: boolean;
  actionConfirmationTitle?: string;
  actionConfirmationDescription?: string;
}

export interface HeaderToolbarConfig<T extends FilterType> {
  title: string;
  subtitle?: string;
  viewMode: string;
  searchQuery: string;
  filters: T;
  selectedItems?: string[];
  showFileUpload?: boolean;
  showFolderCreate?: boolean;
  filterConfigs: FilterConfig[];
  actions?: ActionConfig[];
  onViewModeChange: (mode: string) => void;
  onSearchChange: (query: string) => void;
  onFiltersChange: (filters: T) => void;
  onFileUpload?: (files: File[]) => void;
  onFolderCreate?: (name: string) => void;
  showTitle?: boolean;
}

export const fileTypeFilter = {
  key: 'fileType',
  type: 'select',
  label: 'FILE_TYPE',
  options: [
    { value: 'Folder', label: 'FOLDER' },
    { value: 'File', label: 'FILE' },
    { value: 'Image', label: 'IMAGE' },
    { value: 'Audio', label: 'AUDIO' },
    { value: 'Video', label: 'VIDEO' },
  ],
  width: 'w-[140px]',
};

export const fileTypeFilterConfig: FilterConfig = {
  key: 'fileType',
  type: 'select',
  label: 'FILE_TYPE',
  options: [
    { value: 'Folder', label: 'FOLDER' },
    { value: 'File', label: 'FILE' },
    { value: 'Image', label: 'IMAGE' },
    { value: 'Audio', label: 'AUDIO' },
    { value: 'Video', label: 'VIDEO' },
  ],
  width: 'w-[140px]',
};

export interface FileTypeFilterOptions {
  /** When true (e.g. Media Library route), include Photo in the type filter. Omitted for Document Management. */
  includePhoto?: boolean;
}

export const getFileTypeFilterConfig = (options?: FileTypeFilterOptions): FilterConfig => ({
  key: 'fileType',
  type: 'select',
  label: 'FILE_TYPE',
  options: [
    // ...(isMediaLibrary ? [] : [{ value: 'Folder', label: 'FOLDER' }]),
    // { value: 'File', label: 'FILE' },
    // { value: 'Image', label: 'IMAGE' },
    // { value: 'Audio', label: 'AUDIO' },
    // { value: 'Video', label: 'VIDEO' },
    { value: 'Pdf', label: 'PDF' },
    { value: 'Document', label: 'DOCUMENT' },
    { value: 'Spreadsheet', label: 'SPREADSHEET' },
    ...(options?.includePhoto ? [{ value: 'Photo', label: 'PHOTO' }] : []),
    { value: 'Xlsx', label: 'XLSX' },
    { value: 'Csv', label: 'CSV' },
    { value: 'Vsdx', label: 'VSDX' },
    { value: 'Pptx', label: 'PPTX' },
    { value: 'Json', label: 'JSON' }
  ],
  width: options?.includePhoto ? 'w-[140px]' : 'w-[180px]',
});
